import clsx from 'clsx';
import React from 'react';

import { ExpressionEditor, type ExpressionEditorProps } from './ExpressionEditor';

/**
 * Utility component to render a text input for a template expression.
 */
export function ExpressionTemplateInput(
    props: Omit<ExpressionEditorProps, 'mode'> & {
        className?: string;
    }
) {
    const { className, ...rest } = props;
    const [isFocused, setIsFocused] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);

    return (
        <div
            className={clsx(
                'rounded border bg-action-secondary',
                isFocused && !hasError ? 'border-primary' : 'border-control-border-default',
                hasError ? 'border-control-invalid' : null,
                className
            )}
        >
            <ExpressionEditor
                {...rest}
                mode="template"
                onFocus={() => {
                    setIsFocused(true);
                    rest.onFocus?.();
                }}
                onBlur={() => {
                    setIsFocused(false);
                    rest.onBlur?.();
                }}
                onChange={(value, error) => {
                    rest.onChange(value, error);
                    setHasError(!!error);
                }}
            />
        </div>
    );
}
